export enum SPINNER_SIZES {
    SMALL = 20,
    DEFAULT = 40,
    MOBILE_APP_WEBVIEW = 90
}
